import React, {useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TextField,
  Grid
} from "@material-ui/core";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import UserManagementPageApis from "../services/UserManagementPageServices";
import NoDataFound from "../../../common-components/no-data-found/NoDataFound";
import CommonUtils from "../../../services/utils";
import UserManagementPageDataSetter from "../services/UserManagementPageUtils";

const useStyles = makeStyles((theme) => ({
  root: {
    height: window.innerHeight,
    width: '100%',
  },
  card: {
    width: '94%',
    marginLeft: '3%',
    marginTop: '1%',
    backgroundColor: 'whitesmoke',
  },
  header: {
    backgroundColor: '#0055a4',
  },
  headerText: {
    fontSize: 23,
    paddingBottom: 5,
    color: 'white',
  },
  logo: {
    width: '5%',
    paddingTop: 20,
    paddingLeft: 15,
    paddingBottom: 0,
    paddingRight: 5,
  },
  table: {
    minWidth: 650,
    overflow:'auto'
  },
  tableHeaderCell: {
    padding: '4px 8px', // Reduced padding for header cells
    fontSize: '0.875rem', // Smaller font size for header cells
    fontWeight: 'bold', // Bold font for header cells
  },
  tableCell: {
    padding: '4px 8px',
  },
  button: {
    margin: theme.spacing(0.5),
    padding: theme.spacing(0.5),
  },
  disabledButton: {
    color:'lightgrey',
  }
}));

// USED FOR SORTING
function descendingComparator(a, b, orderBy) {
  if (typeof a[orderBy] === 'string' && typeof b[orderBy] === 'string') {
     let firstVal = a[orderBy].toLowerCase().trim()
     let secondVal = b[orderBy].toLowerCase().trim()
     if (secondVal < firstVal) {
       return -1;
     }
     if (secondVal > firstVal) {
       return 1;
     }
     return 0;

   } else {
    let firstVal = a[orderBy]
    let secondVal = b[orderBy]
    if (secondVal < firstVal) {
      return -1;
    }
    if (secondVal > firstVal) {
      return 1;
    }
    return 0;
  }
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function GrandparentAccountTable() {
  const classes = useStyles();
  const userManagementPageApi = new UserManagementPageApis();
  const commonUtils = new CommonUtils();
  const userManagementPageDataSetter = new UserManagementPageDataSetter();
  const [userList, setUserList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("LocationName");
  const [arrRowsPerPageOptions, setArrRowsPerPageOptions] = useState([]);
  const [searchGrandparentValue, setSearchGrandparentValue] = useState("");
  const [originalUserList, setOriginalUserList] = useState([]);
  useEffect(() => {
    userManagementPageApi.getGrandparentAccountList().then((response) => {
      if (response.model.length > 0)
      setUserList(response.model)
      setOriginalUserList(response.model)
    })  
    let row = [];
    row.length = userList.length;
    for (let i = 0; i < userList.length; i++) {
      row[i] = false;
    }
    let arr = commonUtils.rowPerPageSelector(userList.length);
    setArrRowsPerPageOptions(arr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]) 


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

      // USED FOR SEARCHING THE TABLES
      const searchTableData = (event) => {
        setSearchGrandparentValue(event.target.value);
        let searchText = event.target.value.toLowerCase();
        let filteredData = userManagementPageDataSetter.searchGrandparent(originalUserList, searchText);
        setUserList(filteredData);
      };

  return (
    <div>
              <TableContainer>
                <Paper className={classes.card}>
                <Grid item sm={12} style={{marginBottom:10}}>
              <TextField
              margin="dense"
              name="searchGrandparentInfo"
              label="Search Grandparent"
              type="text"
              value={searchGrandparentValue}
              onChange={searchTableData}
              className={classes.formField}
              variant="outlined"
              style={{marginRight:40}}
            />

            </Grid>
                <Table className={classes.table} aria-label="simple table" size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeaderCell}>Grandparent Acc ID</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Grandparent Acc Name</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Owned By</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Created By</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Create Date</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Updated By</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Update Date</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Is Active</TableCell>
                  </TableRow>
                </TableHead>
                {userList.length > 0 && (
                <TableBody>
                  {stableSort(
                    userList,
                    getComparator(order, orderBy)
                  )
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      return (
                        <TableRow key={row.userId} size="small">
                        <TableCell className={classes.tableCell}>{row.grandParentAccountId}</TableCell>
                        <TableCell className={classes.tableCell}>{row.grandParentAccountName}</TableCell>
                        <TableCell className={classes.tableCell}>{row.ownedBy}</TableCell>
                        <TableCell className={classes.tableCell}>{row.createdBy}</TableCell>
                        <TableCell className={classes.tableCell}>{row.createdDate ? commonUtils.formatISODate(row.createdDate) : ""}</TableCell>
                        <TableCell className={classes.tableCell}>{row.updatedBy}</TableCell>
                        <TableCell className={classes.tableCell}>{row.updatedDate ? commonUtils.formatISODate(row.updatedDate) : ""}</TableCell>
                        <TableCell className={classes.tableCell}>{row.isActive ? <CheckCircleOutlineIcon style={{color:"green", marginLeft:15}}/> : <RadioButtonUncheckedIcon style={{color:"gray"}}/>}</TableCell>
                    </TableRow>
                      );
                    })}
                </TableBody>
              )}
              </Table>
              {userList.length === 0 && (
                <TableBody>
                  <TableRow>
                    <TableCell
                      className="no-match-found"
                      colSpan={8}
                      align="center"
                    >
                      <div className="no-data-container">
                        <NoDataFound noDataType="table"></NoDataFound>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
                </Paper>
              </TableContainer>
              <TablePagination
            rowsPerPageOptions={arrRowsPerPageOptions}
            component="div"
            count={userList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            SelectProps={{
              inputProps: {
                'aria-label': 'rows per page',
              },
              native: true,
            }}
          />
    </div>
  );
}

export default GrandparentAccountTable;